// extensions/CustomCell.ts
import { TableCell } from '@tiptap/extension-table-cell';

export const CustomCell = TableCell.extend({
  content: 'block+',

  addAttributes() {
    return {
      ...this.parent?.(),
      role: {
        default: null,
        parseHTML: el => el.getAttribute('data-role'),
        renderHTML: a => (a.role ? { 'data-role': a.role } : {}),
      },
      class: {
        default: null,
        parseHTML: el => el.getAttribute('class'),
        renderHTML: a => (a.class ? { 'class': a.class } : {}),
      },
    };
  }
});
